export const ENGLISH_TRANSLATIONS = {
  title: 'Title',
  description: 'Description',
  titleAndDescription: 'Title and description',
  overview: 'Overview',
  generalInfo: 'General info',
  whatToBring: 'What to bring',
  additionalInfo: 'Additional info',
  cancellation: 'Cancellation / Expiration',
  included: 'Included',
  notIncluded: 'Not included',
  bedDetails: 'Bed details',
  fee: 'Fee',

  titleIsRequired: 'Title is required',
  overviewIsRequired: 'Overview is required',
  cancellationIsRequired: 'Cancellation / Expiration is required',
  cancellationHelpMessage: `Here you need to fill in your cancellation policy and expire of the pass if that is applicable. Example “You can cancel up to 48 hours before the booked date for free, all trips canceled later is nonrefundable”.`,
  includedHelpMessage: `Hit enter for each item. Note, that if you type the text but don't hit enter, the item will not be saved.`,
  'Hit Enter to add an item': 'Hit Enter to add an item'
};
